import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD8x9O164h9gXxcEMW0cqzkNY8U_ZdheyA",
  authDomain: "data-axe-401820.firebaseapp.com",
  projectId: "data-axe-401820",
  storageBucket: "data-axe-401820.firebasestorage.app",
  messagingSenderId: "124679488593",
  appId: "1:124679488593:web:4d7458b5d43ba2406ea470",
  measurementId: "G-QYYL16XG6T"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app, 'prd-advisors-management');
